import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import { withTranslation, Trans } from 'react-i18next';
import { cameraView08DeckWheelsImageOptions } from './views/CameraView08DeckWheels'

class X49Wheel extends Component {
    constructor(props) {
        super(props);
        this.handleWheelChange = this.handleWheelChange.bind(this);
    }


    handleWheelChange(newValue) {
        let configuration = this.props.configuration;
        configuration.Wheel = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = cameraView08DeckWheelsImageOptions;

        let image = <ConfiguratorImage boat="X4_9" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                
                <ConfiguratorOption>
                    <h1><Trans defaults='Wheels' /></h1>

                    <RadioGroup label={this.props.t('Options:')} options={this.props.wheelOptions} value={this.props.configuration.Wheel} onChange={this.handleWheelChange} />

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X49Wheel);


// WEBPACK FOOTER //
// ./src/X49/X49Wheel.js